<template>
  <div class="box">
    <HeaderNav  />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
      <div class="service-range">
        <ScopeServices ref="scopeServicesRef" />
      </div>

      <!--中间图片 开始-->
      <div style="width: 100%;height: 150px;background: #fff">
        <img src="@/assets/images/index_cbj.png"   />
      </div>
      <!--中间图片 结束-->
      <div>
        <productDisplay ref="productDisplayRef" />
      </div>
      <div>
        <!-- 新闻资讯 -->
        <newsList ref="newsListRef" />
      </div>
      <div>
        <!--    我们的客户 -->
        <customerList ref="customerListRef" />
      </div>
    </div>
    <div>
      <FootNav />
    </div>
  </div>
</template>

<script setup>
import HeaderNav from '@/components/headerNav.vue'
import FootNav from '@/components/footNav.vue'
import  {getHomeApi,getBannerApi,getNewsArticleTypeApi  } from  '@/api/index'
import ScopeServices from '@/components/home/scopeServices.vue'
import productDisplay from '@/components/home/productDisplay.vue'
import newsList from '@/components/home/newsList.vue'
import customerList from '@/components/home/customerList.vue'
import { ref,nextTick} from 'vue'
const bannerList = ref([
]),scopeServicesRef = ref(null),productDisplayRef = ref(null),
    newsListRef = ref(null),customerListRef = ref(null)
function  getBanner (){
  getBannerApi({type:1}).then(res => {
    bannerList.value = res.data
  })
}

function getHome () {
  let categoryId = ''
  getHomeApi({type:1}).then(async res => {
    // info.value = res.data
    // getSimpleList()
    categoryId = res.data.id
    await nextTick()
    if(scopeServicesRef.value ){
    getNewsArticleTypeApi({type:1, pageNo :1 ,pageSize:10 ,categoryId}).then(e => {
      scopeServicesRef.value.getInfo(e.data.list,res.data)
    })
    }
  })
  getHomeApi({type:2}).then(async res => {
    categoryId = res.data.id
    await nextTick()
    if(productDisplayRef.value ){
    getNewsArticleTypeApi({type:6, pageNo :1 ,pageSize:10 ,isHome:true}).then(e => {
      productDisplayRef.value.getInfo(e.data.list,res.data)
    })
    }
  })
  getHomeApi({type:3}).then(async res => {
    categoryId = res.data.id
    await nextTick()

    if(newsListRef.value ){
      getNewsArticleTypeApi({type:5, pageNo :1 ,pageSize:10 ,isHome:true}).then(e => {
        newsListRef.value.getInfo(e.data.list,res.data)
        console.log(e.data.list ,'565')
      })
    }

  })
  getHomeApi({type:4}).then(async res => {
    categoryId = res.data.id
    await nextTick()
    if(customerListRef.value ){
      getNewsArticleTypeApi({type:1, pageNo :1 ,pageSize:10 ,categoryId}).then(e => {
      customerListRef.value.getInfo(e.data.list,res.data)
    })
    }
  })
}
getHome ()
getBanner ()

</script>
